export default {
    goodsClassify: {
        page: {
            SearchCategory: 'Search Category',
            AllCategories: 'All Categories',
            CategoryType: 'Category Type',
            ParentClass: 'Parent Category',
            AddCategory: 'Add Category',
        },
        table: {
            ClassificationName: 'Charge Item',
            ClassificationCode: 'Category Code',
            ParentClass: 'Parent Category',
            Type: 'Type',
            bindingAttributes: 'Bound Attribute Quantity',
            Remarks: 'Remarks',

            Attributename: 'Attribute Name',
            Attributecode: 'Attribute Code',
            Attributemethod: 'Form Method',
            Attributevalue: 'Attribute Value',
            AttributeType: 'Attribute Type',
            Attributesource: 'Attribute Source',
            AttributeSKU: 'Generate SKU or not',
            DragSort: 'Drag and Sort',
        },
        dialog: {
            CEN: 'Chinese/English/Numeric',
            lettersNumbers: '0-20 English letters and numbers',
            ParentClassification: 'Parent Category',
            LeafNode: 'Leaf node or not',
            WhenLeafNode: 'When set as a leaf node, it is impossible to add subcategories, and the product is mounted on the leaf node',
            Remarks: 'Remarks',
            category: 'Please select the parent category',
            EditClassification: 'Edit category',
            CreateCategory: 'Create new category',
        },
        common: {
            ClassificationName: 'Charge Item',
            ClassificationCode: 'Category code',
        },
        dialogTable: {
            titleName: 'Attribute Table',
            attributes: 'Import category attributes',
            superior: 'Copy parent attributes',
            AddAttribute: 'Add attribute',
            EditAttribute: 'Edit attribute',
            BasicInformation: 'Account Information',
            Presentation: 'Display method',
            corresponding: 'Display mode as radio button, checkbox, or dropdown box requires corresponding attribute values to be added.',
            GenerateSKU: 'Generate SKU',
            InformationContent: 'Information content',
            AlreadyExists: 'Already exists, please reset'
        }
    }
};
